{
 "COMMON": {
  "CANCEL": "Cancel",
  "CLEAN": "Clean",
  "OK": "OK",
  "NEXT": "Next",
  "BACK": "Back",
  "SKIP": "Skip",
  "CONTINUE": "Continue",
  "NEW": "New",
  "TRUE": "True",
  "FALSE": "False",
  "FILTERS": "Filters",
  "VERSION": "Version",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "SAVE": "Save",
  "DELETE": "Delete",
  "CONFIRM_DELETE": "Confirm deletion",
  "CONFIRM_DELETE_BODY": "Are you sure you want to delete {{name}}?",
  "DELETE_SUCCESS": "Deleted successfully",
  "CREATE_SUCCESS": "Created successfully",
  "UPDATE_SUCCESS": "Updated successfully",
  "LOADING": "Loading…",
  "SECURITY": "Security",
  "SEARCH": "Search",
  "NAME": "Name",
  "ADD": "Add",
  "UPDATE": "Update",
  "EDITING": "Editing: {{name}}"
 },
 "IMAGE_VIEWER": {
  "ZOOM_IN": "Zoom in",
  "ZOOM_OUT": "Zoom out",
  "FIT": "Fit",
  "CLOSE": "Close",
  "HINT": "Pinch or use the wheel to zoom · double-tap to zoom there"
 },
 "APP": {
  "EXIT_CONFIRM": "Do you want to exit the app?"
 },
 "ERROR": {
  "HEADER": "Alert",
  "UNEXPECTED": "Unexpected error",
  "STATUS": "Status: {{status}}",
  "NETWORK": "Network error. Check your connection."
 },
 "UPDATE": {
  "READY": "A new version is available",
  "RELOAD": "Update Now",
  "MODAL_TITLE": "Update Available",
  "NEW_VERSION": "A new version of the app is ready. Reload to get the latest features and improvements.",
  "LATER": "Later",
  "UP_TO_DATE": "You are on the latest version",
  "UNAVAILABLE": "Automatic updates are not available in this environment"
 },
 "NETWORK": {
  "OFFLINE": "No connection — working in offline mode",
  "ONLINE": "Connection restored",
  "SYNCED": "Local data synced successfully",
  "SYNCED_PARTIAL": "Some changes could not be synced — will retry on the next connection",
  "SAVED_OFFLINE": "Saved locally — will sync on reconnect",
  "NO_CACHED_PRODUCTS": "No products available offline. Connect to the internet to load the product catalog."
 },
 "CONFIG": {
  "INTRO": "The <b>APP</b> where you can manage your <u>Perfect Store</u> in real time.",
  "PERFECT_STORE": {
   "TITLE": "What is a Perfect Store?",
   "BODY": "<b>Perfect Store</b> is a trade marketing strategy that pursues excellence at the point of sale (POS) to drive sales"
  },
  "PREFERENCES": {
   "TITLE": "Make it yours",
   "BODY": "Choose your language and appearance. You can change this anytime from Settings.",
   "LANGUAGE": "Language",
   "DARK_MODE": "Dark mode"
  },
  "READY": {
   "TITLE": "All set to get started?",
   "BODY": "Everything is ready. You can adjust your preferences anytime from Settings.",
   "START": "Get started"
  },
  "APPEARANCE": {
   "TITLE": "Appearance",
   "BODY": "Switch between light and dark mode."
  },
  "ERROR": {
   "HEADER": "Alert",
   "SUBHEADER": "Invalid code",
   "MESSAGE": "Could not load the initial configuration. Check your connection and try again."
  }
 },
 "LOGIN": {
  "WELCOME": "Welcome",
  "SUBTITLE": "Sign in to continue",
  "USERNAME": "Username",
  "PASSWORD": "Password",
  "SUBMIT": "Sign in",
  "FAILED_HEADER": "Login failed",
  "FAILED_MESSAGE": "Access denied.",
  "ROLE_NOT_SUPPORTED": "Your user role does not have access to this application."
 },
 "MENU": {
  "TITLE": "Menu",
  "ITEMS": {
   "PRODUCTS": "Products",
   "DASHBOARD": "Dashboard",
   "MARKETERS": "Marketers",
   "ROUTES": "Routes",
   "CHAINS": "Chains",
   "REPORTS": "Reports",
   "PERFECT_STORE": "Perfect Store"
  }
 },
 "POS": {
  "TITLE": "POS",
  "TOTAL": "Total",
  "TAXES": "Taxes",
  "QTY": "Qty.",
  "DISCOUNT": "Disc.",
  "PRICE": "Price"
 },
 "CUSTOMER": {
  "TITLE": "Customers",
  "EMPTY_TITLE": "No customers yet",
  "EMPTY_BODY": "Customers you register will appear in this list."
 },
 "DASHBOARD": {
  "TITLE": "Dashboard",
  "SUMMARY_TITLE": "Summary",
  "QUICK_ACTIONS_TITLE": "Quick Access",
  "CHECK_UPDATES": "Check Updates",
  "KPI": {
   "COMPLETED": "Completed",
   "PENDING_SYNC": "Pending sync",
   "AVG_VISIT_DURATION": "Avg. visit duration",
   "AVG_SYNC_TIME": "Sync time"
  },
  "CHARTS": {
   "TITLE": "Charts",
   "VISITS": "Visits: planned vs completed",
   "PLANNED": "Planned",
   "COMPLETED": "Completed"
  },
  "ASSIGNMENTS": {
   "TITLE": "My assignments",
   "SYNC": "Sync assignments",
   "SUMMARY": "{{routes}} routes · {{pos}} POS",
   "POS_PER_ROUTE": "POS per route",
   "POS_BY_DAY": "POS to visit by day",
   "EMPTY_TITLE": "No assignments yet",
   "EMPTY_BODY": "Use 'Sync' to download your routes and points of sale.",
   "ROUTE_POS_TREEMAP": "Route · POS tree",
   "TREEMAP_ROOT": "All routes",
   "TREEMAP_VISIT": "Visit freq",
   "TODAY": "Today's routes",
   "START_VISIT": "Start visit"
  },
  "SYNC_ALL": "Sync everything",
  "VISIT_IN_PROGRESS": "Visit in progress",
  "CONTINUE_VISIT": "Continue",
  "DAYS": {
   "MON": "Mon",
   "TUE": "Tue",
   "WED": "Wed",
   "THU": "Thu",
   "FRI": "Fri",
   "SAT": "Sat"
  },
  "PERFECT_STORE": {
   "TITLE": "Perfect Store"
  }
 },
 "MARKETER": {
   "TITLE": "Marketers",
   "NEW_BUTTON": "New",
   "ACTIVE_HEADER": "Active marketers",
   "NEW_TITLE": "New Marketer",
  "EDIT_TITLE": "Edit Marketer",
  "EMPTY": "No marketers registered",
  "DUPLICATE_EMAIL": "A marketer with this email already exists",
  "NOT_FOUND": "Marketer not found.",
  "VALIDATION_ERROR": "Validation error. Please check the entered data.",
  "IMAGE_FORMAT_ERROR": "Unsupported image format. Use JPEG, PNG, GIF or WebP.",
  "IMAGE_SIZE_ERROR": "Image is too large. Please select a smaller image.",
  "LAST_LOGIN": "Last login",
  "FORM": {
   "NAME": "Full name",
   "EMAIL": "Email address",
   "PASSWORD": "Password",
   "PHONE": "Phone number",
   "ACTIVE": "Active",
   "IMAGE": "Add photo"
  }
 },
 "PAYMENT": {
  "TITLE": "Register payment",
  "EMPTY_TITLE": "No payments recorded",
  "EMPTY_BODY": "Payments you record will show up on this screen."
 },
 "PRODUCT": {
  "TITLE": "Product catalog",
  "DETAIL_TITLE": "Product",
  "MODIFY_FILTERS": "Modify filters",
  "NEW": "New product",
  "EDIT_TITLE": "Edit product",
  "EMPTY_TITLE": "No products found",
  "EMPTY_BODY": "Products you add will show up on this screen.",
  "SEARCH": "Search products",
  "DOWNLOAD_TEMPLATE": "Download template",
  "IMPORT": "Import",
  "IMPORT_RESULT": "Imported: {{total}} total, {{created}} created, {{updated}} updated, {{errors}} errors",
  "IMPORT_RESULT_HEADER": "Import completed",
  "IMPORT_ERROR_ROW": "Row {{row}}: {{message}}",
  "IMPORT_ERROR": "Import failed. Check the file format and try again.",
  "IMPORT_DOWNLOAD_ERROR": "Could not download the template. Try again.",
  "DELETE_CONFIRM_BODY": "Are you sure you want to delete \"{{name}}\"?",
  "FIELDS": {
   "NAME": "Name",
   "SKU": "SKU",
   "INTERNAL_CODE": "Internal code",
   "CATEGORY": "Category",
   "SUBCATEGORY": "Subcategory",
   "MANUFACTURER": "Manufacturer",
   "BRAND": "Brand",
   "UNIT": "Unit",
   "PACKAGING": "Packaging type",
   "IS_INTERNAL": "Own brand (scored in Perfect Store)",
   "INTERNAL": "Internal",
   "COMPETITION": "Competition",
   "IMAGE": "Product image",
   "SELECT_IMAGE": "Select image",
   "REMOVE_IMAGE": "Remove image",
   "NO_CATEGORIES_HINT": "No categories available — create them first"
  },
  "ERRORS": {
   "NOT_FOUND": "Product not found",
   "CONFLICT": "Conflict: the product could not be saved",
   "VALIDATION": "Invalid data. Check the fields and try again.",
   "DELETE_CONFLICT": "This product cannot be deleted because it has associated records.",
   "IMAGE_TYPE": "Invalid image type. Use JPEG, PNG, or WebP.",
   "IMAGE_SIZE": "Image exceeds the maximum allowed size (5 MB)."
  },
  "MANAGE": {
   "CATEGORIES": "Categories",
   "SUBCATEGORIES": "Subcategories",
   "MANUFACTURERS": "Manufacturers",
   "BRANDS": "Brands",
   "UNITS": "Units",
   "PACKAGING": "Packaging types",
   "ADD": "Add new"
  }
 },
 "FILTER": {
  "TITLE": "Modify filters",
  "NEW_FILTER": "New filter",
  "FIELD": "Field",
  "FIELDS": "Fields",
  "VALUE": "Value",
  "NAME_IS": "{{field}} is {{value}}"
 },
 "REPORT": {
  "TITLE": "Reports",
  "SELECT_REPORT": "Select report",
  "APPLY_FILTERS": "Apply filters",
  "CLEAR_FILTERS": "Clear filters",
  "NO_REPORTS": "No reports available",
  "LOAD_ERROR": "Error loading report",
  "RETRY": "Retry",
  "EXPORTING": "Exporting full report...",
  "REFRESH": "Refresh",
  "YES": "Yes",
  "NO": "No",
  "ALL": "All",
  "DATE": "Date",
  "PRODUCT": "Product",
  "SKU": "SKU",
  "CATEGORY": "Category",
  "MARKETER": "Marketer",
  "SALES_POINT": "Sales Point",
  "REGION": "Region",
  "CHANNEL": "Channel",
  "REVENUE": "Revenue",
  "UNITS": "Units",
  "TARGET": "Target",
  "COMPLIANCE": "Compliance",
  "STATUS": "Status",
  "VISIT_TYPE": "Visit Type",
  "ADD_FILTER": "Add filter",
  "FIELD": "Field",
  "OPERATOR": "Operator",
  "VALUE": "Value",
  "CONTAINS": "contains",
  "EQUALS": "equals",
  "GREATER_THAN": "greater than",
  "LESS_THAN": "less than",
  "SHOWING": "Showing {{start}}-{{end}} of {{total}} results",
  "PREVIOUS": "Previous",
  "NEXT": "Next",
  "PER_PAGE": "per page",
  "FILTER_BY": "Filter by",
  "NO_RESULTS": "No results match your filters",
  "COLUMNS": "Columns",
  "EXPORT": "Export",
  "EXPORT_CSV": "Export CSV",
  "EXPORT_EXCEL": "Export Excel",
  "EXPORT_PDF": "Export PDF",
 "EVIDENCE_TITLE": "Evidence photo",
  "COLUMN_KEYS": {
   "id": "ID",
   "visit_id": "Visit ID",
   "visit_start_date": "Start Date",
   "visit_end_date": "End Date",
   "visit_duration": "Duration",
   "visit_sync_duration": "Sync Time",
   "visit_create_date": "Created At",
   "marketer_name": "Marketer",
   "marketer_email": "Marketer Email",
   "marketer_phone": "Marketer Phone",
   "pos_name": "POS",
   "pos_address": "POS Address",
   "chain_name": "Chain",
   "region_name": "Region",
   "route_name": "Route",
   "availability": "Availability",
   "availability_label": "Availability",
   "product_name": "Product",
   "product_sku": "SKU",
   "product_internal_code": "Internal Code",
   "product_category_name": "Category",
   "product_subcategory_name": "Subcategory",
   "product_manufacturer_name": "Manufacturer",
   "product_brand_name": "Brand",
   "product_unit_name": "Unit",
   "product_packaging_type_name": "Packaging",
  "product_is_internal": "Internal Brand",
  "shelf_visibility_cm": "Shelf Visibility (cm)",
  "product_visibility_cm": "Product Visibility (cm)",
  "has_price": "Visible Price",
  "price": "Price",
  "has_discount_price": "Discount Price",
  "discount_price": "Discount Price",
  "is_direct_block": "Direct Block",
  "is_shelf_level": "Shelf Level",
  "has_competitor": "Competitor",
  "has_evidence_image": "Evidence Photo",
  "evidence_image_url": "Photo URL",
  "name": "Marketer",
   "email": "Email",
   "phone": "Phone",
   "visits": "Visits",
   "duration": "Total Duration",
   "avg_duration": "Avg Duration",
   "products": "Products Evaluated",
   "pos": "POS",
   "routes": "Routes",
   "first_visit": "First Visit",
   "last_visit": "Last Visit",
   "marketer_id": "Marketer ID",
   "pos_id": "Point of Sale ID",
   "chain_id": "Chain ID",
   "region_id": "Region ID",
   "route_id": "Route ID",
   "version_name": "Weighting",
   "evaluable": "Evaluable",
   "reason": "Reason",
   "indicator_weight": "Indicator weight",
   "score": "Availability score",
   "earned": "Points earned",
   "lost": "Points lost",
   "ceiling": "PSS ceiling",
   "max_band_name": "Best reachable band",
   "max_band_color": "Band color",
   "skus_expected": "SKUs evaluated",
   "skus_registered": "SKUs recorded",
   "visits_evaluable": "Evaluable visits",
   "last_visit_id": "Last visit ID",
   "last_visit_date": "Last visit",
   "last_visit_evaluable": "Last visit evaluable",
   "last_visit_score": "Last visit score",
   "last_visit_max_band_name": "Last visit band",
   "last_visit_max_band_color": "Last visit band color",
   "pss_is_evaluated": "Evaluated in Perfect Store",
   "pss_segment": "Size (PS)",
   "pss_compliance": "Compliance (PS)",
   "pss_sku_weight": "SKU weight (PS)",
   "osa_score": "Availability score",
   "osa_earned": "Availability earned",
   "osa_lost": "Availability lost",
   "vis_status": "Visibility",
   "vis_reason": "Not measured reason",
   "vis_shelf_cm": "Shelf (cm)",
   "vis_vale_cm": "Own brand (cm)",
   "vis_participation": "Shelf share",
   "vis_step1": "Visibility step 1",
   "vis_step2": "Visibility step 2",
   "vis_visit_score": "Visit score (Visibility)",
   "vis_score": "Visibility score",
   "vis_earned": "Visibility earned",
   "vis_lost": "Visibility lost",
   "pss_partial": "Partial PSS",
   "pss_excluded_weight": "Not measured weight",
   "vis_visits_no_measurement": "Visits not measured (Visibility)",
   "last_visit_osa_score": "Last visit availability",
   "last_visit_vis_score": "Last visit visibility",
   "last_visit_ceiling": "Last visit ceiling",
   "vis_compliance": "Visibility compliance (PS)",
   "tag_status": "Price tag",
   "tag_reason": "Not measured reason (Price tag)",
   "tag_skus_with_stock": "SKUs in stock",
   "tag_skus_compliant": "SKUs with price tag",
   "tag_score": "Price tag score",
   "tag_earned": "Price tag earned",
   "tag_lost": "Price tag lost",
   "list_status": "List price",
   "list_reason": "Not measured reason (List price)",
   "list_skus_compliant": "SKUs at or below list price",
   "list_capture_warnings": "Prices to check",
   "list_score": "List price score",
   "list_earned": "List price earned",
   "list_lost": "List price lost",
   "tag_visits_no_measurement": "Visits not measured (Price tag)",
   "list_visits_no_measurement": "Visits not measured (List price)",
   "last_visit_tag_score": "Last visit price tag",
   "last_visit_list_score": "Last visit list price",
   "tag_compliance": "Price tag compliance (PS)",
   "tag_sku_weight": "Price tag SKU weight (PS)",
   "tag_contribution": "Price tag contribution (PS)",
   "list_price": "List price",
   "list_compliance": "List price compliance (PS)",
   "list_sku_weight": "List price SKU weight (PS)",
   "comp_status": "Competition",
   "struct_status": "Structure",
   "act_status": "Activation",
   "act_reason": "Reason (Activation)",
   "act_skus_negotiated": "Negotiated SKUs",
   "act_skus_compliant": "SKUs with the promotion in place",
   "act_score": "Activation score",
   "act_earned": "Activation earned",
   "act_lost": "Activation lost",
   "act_visits_not_applicable": "Visits without negotiation",
   "act_visits_no_measurement": "Visits not measured (Activation)",
   "last_visit_act_score": "Last visit activation",
   "pss_final": "Final PSS",
   "final_band_name": "Final traffic light",
   "final_band_color": "Final traffic light color",
   "pss_evaluable_weight": "Possible points",
   "last_visit_pss_final": "Last visit final PSS",
   "last_visit_final_band_name": "Last visit final traffic light",
   "last_visit_final_band_color": "Last visit final traffic light color",
   "act_negotiated": "Negotiated (PS)",
   "act_discount": "Negotiated discount (PS)",
   "act_target_price": "Maximum offer price (PS)",
   "act_step1": "Offer tag (PS)",
   "act_step2": "Offer price (PS)",
   "act_compliance": "Activation compliance (PS)",
   "act_sku_weight": "Activation SKU weight (PS)",
   "act_contribution": "Activation contribution (PS)",
   "struct_reason": "Not measured reason (Structure)",
   "struct_skus_compliant": "SKUs with full layout",
   "struct_score": "Structure score",
   "struct_earned": "Structure earned",
   "struct_lost": "Structure lost",
   "struct_visits_no_measurement": "Visits not measured (Structure)",
   "last_visit_struct_score": "Last visit structure",
   "struct_compliance": "Structure compliance (PS)",
   "struct_sku_weight": "Structure SKU weight (PS)",
   "struct_contribution": "Structure contribution (PS)",
   "comp_reason": "Not measured reason (Competition)",
   "comp_capture_warnings": "Outlier prices",
   "comp_score": "Competition score",
   "comp_earned": "Competition earned",
   "comp_lost": "Competition lost",
   "comp_visits_no_measurement": "Visits not measured (Competition)",
   "last_visit_comp_score": "Last visit competition",
   "comp_role": "Role (Competition)",
   "comp_block": "Block (Competition)",
   "comp_kg": "Kg",
   "comp_price_per_kg": "Price per kilo ($/kg)",
   "comp_price_status": "Competitor price",
   "comp_competitor_avg": "Competition average ($/kg)",
   "comp_discount": "Discount vs competition",
   "comp_compliance": "Competition compliance (PS)",
   "comp_sku_weight": "Competition SKU weight (PS)",
   "comp_contribution": "Competition contribution (PS)",
   "list_contribution": "List price contribution (PS)",
   "list_warning": "Price warning (PS)",
   "vis_sku_weight": "Visibility SKU weight (PS)",
   "vis_contribution": "Visibility contribution (PS)",
   "pss_contribution": "PSS contribution (PS)"
  },
  "FILTER_LABELS": {
   "date_from": "Visit End From",
   "date_to": "Visit End To",
   "marketer_name": "Marketer",
   "pos_name": "POS",
   "chain_name": "Chain",
   "region_name": "Region",
   "route_name": "Route",
   "product_name": "Product",
   "product_sku": "SKU",
   "product_internal_code": "Internal Code",
   "category_name": "Category",
   "subcategory_name": "Subcategory",
   "manufacturer_name": "Manufacturer",
   "brand_name": "Brand",
   "unit_name": "Unit",
   "packaging_type_name": "Packaging Type",
   "availability": "Availability",
   "is_internal": "Internal Product",
   "marketer_id": "Marketer ID",
   "pos_id": "POS ID",
   "chain_id": "Chain ID",
   "region_id": "Region ID",
   "route_id": "Route ID",
   "product_id": "Product ID",
   "category_id": "Category ID",
   "subcategory_id": "Subcategory ID",
   "manufacturer_id": "Manufacturer ID",
   "brand_id": "Brand ID",
   "unit_id": "Unit ID",
   "packaging_type_id": "Packaging Type ID"
  },
  "FILTER_GROUP": {
   "DATES": "Dates",
   "VISIT": "Visit",
   "PRODUCT": "Product",
   "STATUS": "Status",
   "IDS": "IDs",
   "OTHER": "Other"
  },
  "FROM": "From",
  "TO": "To",
  "CLEAR_ALL": "Clear all",
  "REMOVE_FILTER": "Remove {{filter}} filter",
  "FILTER_SEARCH": "Search filters...",
  "ACTIVE_FILTERS": "Active filters",
  "SHOW_LESS": "Show less",
  "MORE_FILTERS": "More filters ({{count}})",
  "FILTER_ACTIVE": "filter active",
  "FILTERS_ACTIVE": "filters active",
  "FILTER_OPTIONS": {
   "availability": {
    "zero": "0 units",
    "low": "1-20 units",
    "high": "More than 20 units"
    },
   "is_internal": {
    "true": "Yes",
    "false": "No"
   }
  },
  "AVAILABILITY_LEVELS": {
   "zero": "Out of stock",
   "low": "Low stock",
   "high": "In stock"
  }
 },
 "PAGINATION": {
   "SHOWING": "Showing {{start}}-{{end}} of {{total}} results"
  },
 "ROUTE": {
  "TITLE": "Routes",
  "ACTIVE_HEADER": "Active routes",
  "NEW": "New Route",
  "EDIT_TITLE": "Edit Route",
  "EMPTY_TITLE": "No routes yet",
  "EMPTY_BODY": "Routes you create will appear here.",
  "POS_COUNT": "{{count}} POS",
  "NO_MARKETER": "Unassigned",
  "UNASSIGNED": "Unassigned",
  "ASSIGN_MARKETER": "Assign Marketer",
  "UNASSIGN_MARKETER": "Unassign",
  "MARKETER_AFTER_CREATE": "Marketer assignment will be available after creating the route.",
  "ADD_POS": "Add POS",
  "DELETE_CONFIRM_BODY": "Are you sure you want to delete {{name}}?",
  "FIELDS": {
   "NAME": "Route name",
   "MARKETER": "Marketer",
   "POS_ASSIGNMENTS": "POS assignments",
   "VISIT_FREQUENCY": "Visit frequency",
   "VISIT_DAYS": "Visit days"
  },
  "DAYS": {
   "MON": "Mon",
   "TUE": "Tue",
   "WED": "Wed",
   "THU": "Thu",
   "FRI": "Fri",
   "SAT": "Sat",
   "SUN": "Sun"
  },
  "ERRORS": {
   "POS_CONFLICT": "POS conflict: {{detail}}",
   "INVALID": "Invalid data: {{detail}}",
   "NOT_FOUND": "Route not found."
  }
 },
 "SALES_POINT": {
  "TITLE": "Points of Sale",
  "POS": "Point of Sale",
  "CHAINS": "Chains",
  "REGIONS": "Regions",
  "EMPTY_POS": "No points of sale found",
  "EMPTY_CHAINS": "No chains found",
  "EMPTY_REGIONS": "No regions found",
  "NEW_POS": "New Point of Sale",
  "EDIT_POS": "Edit Point of Sale",
  "NEW_CHAIN": "New Chain",
  "EDIT_CHAIN": "Edit Chain",
  "NEW_REGION": "New Region",
  "EDIT_REGION": "Edit Region",
  "FORM": {
   "NAME": "Name",
   "CHAIN": "Chain",
   "REGION": "Region",
   "ADDRESS": "Address"
  },
  "DUPLICATE_NAME": "A record with this name already exists",
  "NOT_FOUND": "Record not found",
  "DELETE_ERROR_CHAIN": "Cannot delete: chain has associated points of sale",
  "DELETE_ERROR_REGION": "Cannot delete: region has associated points of sale",
  "DELETE_ERROR_GENERIC": "Cannot delete this record",
  "DOWNLOAD_TEMPLATE": "Download template",
  "IMPORT": "Import",
  "IMPORTING": "Importing points of sale...",
  "IMPORT_RESULT": "Import completed. Total: {{total}} — Created: {{created}} — Updated: {{updated}} — Errors: {{errors}}",
  "IMPORT_ERROR_ROW": "Row {{row}}: {{message}}",
  "IMPORT_COMPLETED": "Import completed",
  "IMPORT_DOWNLOAD_ERROR": "Error downloading template. Please try again.",
  "IMPORT_ERROR": "Error importing data. Check the file format."
 },
 "SHIPPING": {
  "TITLE": "Product delivery",
  "EMPTY_TITLE": "No pending deliveries",
  "EMPTY_BODY": "Scheduled product deliveries will appear here."
 },
 "CHAIN": {
  "TITLE": "Chains",
  "NEW": "New Chain",
  "EDIT_TITLE": "Edit Chain",
  "EMPTY_TITLE": "No chains yet",
  "EMPTY_BODY": "Chains you create will appear here. Link products to a chain so marketers can manage them at the chain's points of sale.",
  "POS_COUNT": "{{count}} POS",
  "PRODUCT_COUNT": "{{count}} products",
  "PRODUCTS_HINT": "Marketers will only see and select the products linked to the chain of the selected point of sale during a visit.",
  "ADD_PRODUCT": "Add product",
  "DOWNLOAD_TEMPLATE": "Download template",
  "IMPORT": "Import",
  "IMPORT_RESULT": "Import completed. Total: {{total}} — Created: {{created}} — Updated: {{updated}} — Errors: {{errors}}",
  "IMPORT_RESULT_HEADER": "Import completed",
  "IMPORT_ERROR_ROW": "Row {{row}}: {{message}}",
  "IMPORT_ERROR": "Error importing data. Check the file format.",
  "IMPORT_DOWNLOAD_ERROR": "Error downloading template. Please try again.",
  "DELETE_CONFIRM_BODY": "Are you sure you want to delete \"{{name}}\"?",
  "FIELDS": {
   "NAME": "Chain name",
   "PRODUCTS": "Linked products",
   "PRODUCT": "Product",
   "PRODUCT_ASSIGNMENT": "Product"
  },
  "ERRORS": {
   "POS_CONFLICT": "Cannot delete: {{detail}}",
   "INVALID": "Invalid data: {{detail}}",
   "NOT_FOUND": "Chain not found."
  },
  "NO_PRODUCTS": "No products linked yet.",
  "ADD_PRODUCTS": "Add products",
  "ADD_SELECTED": "Add ({{count}})",
  "SEARCH_PRODUCTS": "Search products...",
  "NO_MORE_PRODUCTS": "All available products are already linked to this chain.",
  "SELECT_ALL": "Select all",
  "PAGINATION": "Page {{page}} of {{total}}"
 },
 "VISIT": {
  "TITLE": "Visit",
  "NEW_TITLE": "New visit",
  "EDIT_TITLE": "Edit visit",
  "VIEW_TITLE": "Visit Details",
  "VISIT": "Visit",
  "EMPTY_LIST": "No visits yet. Tap + to start a new one.",
  "SYNC": "Sync visits",
  "SYNC_SUCCESS": "All visits synced successfully",
  "SYNC_PARTIAL": "Some visits could not be synced",
  "SYNC_NONE": "No pending visits to sync",
  "SYNC_MANUAL": "Sync now",
  "DELETE_TITLE": "Delete visit",
  "DELETE_MESSAGE": "This draft will be deleted permanently. This action cannot be undone.",
  "DELETED": "Visit deleted",
  "STATUS": {
   "DONE": "Completed",
   "IN_PROGRESS": "In progress",
   "TO_UPLOAD": "Pending sync"
  },
  "TIMER": {
   "TOTAL": "total time"
  },
  "TABS": {
   "ALL": "All",
   "IN_PROGRESS": "In progress",
   "TO_UPLOAD": "Pending",
   "DONE": "Completed"
  },
  "LIST": {
   "DURATION": "Duration",
   "SYNC_TIME": "Sync time"
  },
  "TOUR": {
      "HELP": "Show guide",
      "NEXT": "Next",
      "PREV": "Back",
      "DONE": "Got it",
      "ROUTE_TITLE": "Route and point of sale",
      "ROUTE_TEXT": "Pick the route, then the point of sale you are visiting.",
      "START_TITLE": "Start the visit",
      "START_TEXT": "Tap here once you are at the point of sale. From then on everything saves automatically.",
      "PRODUCTS_TITLE": "Add the products",
      "PRODUCTS_TEXT": "Tap to search and pick each product. Its card opens so you can fill it in.",
      "PHOTO_TITLE": "Shelf photo",
      "PHOTO_TEXT": "Take a photo of the whole shelf. It is required to close the visit.",
      "SUBMIT_TITLE": "Complete the visit",
      "SUBMIT_TEXT": "When every product is done and you have the photo, complete the visit. It cannot be edited afterwards.",
      "SHELF_TITLE": "Shelf measurement",
      "SHELF_TEXT": "Measure the shelf once and enter it here, on the first product. It applies to every product in the visit.",
      "SEARCH_TITLE": "Search a product",
      "SEARCH_TEXT": "Type the name or code of the product in front of you.",
      "FILTER_TITLE": "Pending and recorded",
      "FILTER_TEXT": "\"Pending\" shows what you still need to record at this point of sale; \"Recorded\", what you already filled in.",
      "CATALOG_TITLE": "Pick the product",
      "CATALOG_TEXT": "Tap a product to open its card. A yellow circle means incomplete and a green check means recorded.",
      "AVAILABILITY_TITLE": "Availability",
      "AVAILABILITY_TEXT": "Count the units on the shelf and pick the range. If you choose Zero nothing else is asked for this product.",
      "LINE_DONE_TITLE": "Finish the product",
      "LINE_DONE_TEXT": "Tap \"Done\" to close the card: if something is missing, it tells you what. \"Remove\" takes it out of the visit.",
      "VISIBILITY_TITLE": "Visibility",
      "VISIBILITY_TEXT": "Measure in centimeters the front this product takes up on the shelf.",
      "PRICE_TITLE": "Price",
      "PRICE_TEXT": "Say whether a price tag is visible and enter the regular price, with VAT and without offer.",
      "OFFER_TITLE": "Offer price",
      "OFFER_TEXT": "If you see an offer tag, choose \"Yes\" and enter the offer price.",
      "STRUCTURE_TITLE": "Arrangement",
      "STRUCTURE_TEXT": "Own-brand products only: answer how it is placed. Each question explains what it means below it."
    },
    "FORM": {
   "SECTION_ROUTE": "Route & Point of Sale",
   "SECTION_PRODUCTS": "Products",
   "ROUTE": "Route",
   "SALES_POINT": "Point of Sale",
   "PRODUCT": "Product",
   "PRODUCTS": "products",
   "AVAILABILITY_ZERO": "Zero (0 units)",
   "AVAILABILITY_LOW": "Low (1-20 units)",
   "AVAILABILITY_HIGH": "High (>20 units)",
   "NO_ROUTES": "No routes assigned. Sync your assignments.",
   "NO_POS_FOR_ROUTE": "No points of sale for this route.",
   "SELECT_ROUTE_FIRST": "Select a route first",
   "SELECT_PRODUCT": "Select product",
   "ALREADY_ADDED": "Added",
   "NO_PRODUCTS_YET": "Tap \"Select product\" to record the first one.",
   "NO_PRODUCTS_FOUND": "No products found",
   "CHAIN_PRODUCTS_HINT": "Products for chain \"{{name}}\"",
   "NO_PRODUCTS_FOR_CHAIN": "No products linked to this chain",
   "START_VISIT": "Start Visit",
   "VISIT_STARTED": "Visit started",
   "START_HINT": "Select route and point of sale to start the visit",
   "SUBMIT": "Complete visit",
   "CONFIRM_SUBMIT_TITLE": "Complete visit?",
   "CONFIRM_SUBMIT_MESSAGE": "Once completed, this visit can no longer be edited. Do you want to finish it?",
   "SAVED_OFFLINE": "Saved offline — will sync when connected",
   "SYNCED": "Visit synced successfully",
   "SYNC_FAILED": "Sync failed, will retry later",
   "READ_ONLY": "This visit is already completed",
"VALIDATION_ERROR": "Please fill in all required fields",
  "NO_PRODUCTS": "Add at least one product",
  "MISSING_AVAILABILITY": "Set availability for all products",
  "MISSING_EVAL": "Complete the evaluation of \"{{product}}\"",
  "GENERAL_OBSERVATION": "General notes (optional)",
  "GENERAL_OBSERVATION_PLACEHOLDER": "Write any notes about the visit here...",
  "SECTION_AVAILABILITY": "Availability",
  "SECTION_VISIBILITY": "Visibility",
  "SECTION_PRICE": "Price",
  "SECTION_ACOMODO": "Arrangement",
  "SECTION_OBSERVATION": "Notes",
  "SECTION_PHOTO": "Shelf photo",
  "EVALUATION": "Evaluation",
  "SHELF_VISIBILITY_CM": "Shelf (cm)",
  "SHELF_CM": "Detergent shelf (cm)",
  "SHELF_HINT": "Measure the shelf once: it applies to every product in the visit.",
  "SHELF_EXCEEDED": "Own-brand products add up to {{own}} cm and the shelf is {{shelf}} cm. Check the measures.",
  "MISSING_SHELF": "The shelf measure is missing",
  "PRODUCT_VISIBILITY_CM": "Product (cm)",
  "HAS_PRICE": "Is a pricer visible?",
  "PRICE_HINT": "With VAT, without discount",
  "MISSING_PRICE_TAG": "Indicate whether “{{product}}” has a visible price tag",
  "YES": "Yes",
  "NO": "No",
  "PRICE": "Regular price ($)",
  "HAS_DISCOUNT_PRICE": "Discount price",
  "HAS_DISCOUNT_PRICE_HINT": "Does the product have an offer tag in view?",
  "MISSING_OFFER": "Indicate whether “{{product}}” has a discount price",
  "DISCOUNT_PRICE": "Disc.",
  "IS_DIRECT_BLOCK": "Brand block",
  "IS_DIRECT_BLOCK_HINT": "Are the brand products of the same size together, forming a block, with no other brands between them?",
  "IS_SHELF_LEVEL_HINT": "Is it on the 2 main shelves, at the eye level of an average person?",
  "HAS_COMPETITOR_HINT": "Is it next to the leading competition (for example, Ariel or Las Llaves)?",
  "MISSING_STRUCTURE": "Answer the shelf layout of “{{product}}”",
  "IS_SHELF_LEVEL": "Shelf level",
  "HAS_COMPETITOR": "Next to competition",
 "EVIDENCE_IMAGE": "Point of sale evidence photo",
 "EVIDENCE_HINT": "Take a photo of the point of sale before finishing",
 "EVIDENCE_ADD": "Take / upload photo",
 "EVIDENCE_CHANGE": "Change photo",
 "EVIDENCE_REMOVE": "Remove photo",
 "EVIDENCE_TITLE": "Evidence",
   "CHAIN_PRODUCTS_REQUIRED_HINT": "Products of chain \"{{name}}\": all of them are required in the visit",
   "MISSING_AVAILABILITY_PRODUCT": "Set the availability of \"{{product}}\"",
   "PRODUCT_FILTER_PENDING": "Pending",
   "PRODUCT_FILTER_DONE": "Recorded",
   "PRODUCT_FILTER_ALL": "All",
   "PRODUCT_STATUS_DONE": "Recorded",
   "PRODUCT_STATUS_INCOMPLETE": "Incomplete",
   "NO_PENDING_PRODUCTS": "No pending products left",
   "LINE_DONE": "Done",
   "REMOVE_PRODUCT": "Remove",
   "REMOVE_PRODUCT_TITLE": "Remove product?",
   "REMOVE_PRODUCT_MESSAGE": "The data you recorded for \"{{product}}\" will be deleted.",
   "MISSING_PRODUCTS": "Chain products not yet recorded: {{count}}",
   "RESUME_TITLE": "Visit in progress",
   "RESUME_MESSAGE": "You have an unfinished visit at {{pos}}. Do you want to continue it?",
   "RESUME_CONFIRM": "Continue",
   "RESUME_NEW": "Start another",
   "AUTOSAVE_SAVING": "Saving…",
   "AUTOSAVE_SAVED": "Changes saved on this device",
   "AUTOSAVE_ERROR": "Could not save. Will retry on the next change.",
   "SUMMARY_TITLE": "Visit completed",
   "SUMMARY_DURATION": "Duration: {{duration}}",
   "SUMMARY_PRODUCTS": "Products recorded: {{count}} ({{stock}} in stock, {{zero}} out of stock)",
   "SUMMARY_SYNCED": "Sent to the server.",
   "SUMMARY_SYNC_FAILED": "Could not send; it will retry automatically.",
   "SUMMARY_OFFLINE": "Offline: it will be sent when you are back online."
}
 },
 "SCANNER": {
  "TITLE": "Scanner"
 },
 "PERMISSIONS": {
  "TITLE": "Permissions",
  "STORAGE_SECTION": "Data & Storage",
  "CAMERA": "Camera",
  "STORAGE_PERSISTENCE": "Persistent storage",
  "STORAGE_PERSISTENCE_DESC": "Prevents local data loss under storage pressure",
  "STORAGE_LOCAL_DESC": "App data is stored locally on this device. No external storage permission is required.",
  "STORAGE_ESTIMATE_USED": "Used: {{used}}",
  "STORAGE_ESTIMATE_AVAILABLE": "Available: {{available}}",
  "ESTIMATE_UNAVAILABLE": "Storage estimation not available in this environment",
  "STATUS": {
   "GRANTED": "Granted",
   "PROMPT": "Pending",
   "DENIED": "Denied",
   "PERMANENTLY_DENIED": "Blocked — open system settings to allow",
   "UNAVAILABLE": "Not available on this device"
  },
  "ACTIONS": {
   "REQUEST": "Request permission",
   "OPEN_SETTINGS": "Open settings",
   "RETRY_PERSIST": "Retry persistent storage"
  },
  "CAMERA_RATIONALE_TITLE": "Camera access needed",
  "CAMERA_RATIONALE_MESSAGE": "The scanner uses the camera to read barcodes. This allows you to quickly search products and complete inspections.",
  "CAMERA_DENIED_TITLE": "Camera permission denied",
  "CAMERA_DENIED_MESSAGE": "Camera access was denied. You can change this anytime in your device settings.",
  "CAMERA_BLOCKED_TITLE": "Camera access blocked",
  "CAMERA_BLOCKED_MESSAGE": "Camera permission was permanently blocked. Please enable it in your device settings to use the scanner.",
  "CAMERA_BLOCKED_PWA_MESSAGE": "Camera permission was blocked. Please tap the lock icon in the address bar and enable camera access for this site.",
  "CAMERA_DENIED_PWA_MESSAGE": "Camera access was denied. The scanner needs camera access to read barcodes.",
  "PWA_SETTINGS_INSTRUCTIONS": "Go to your browser settings or tap the lock icon in the address bar to manage site permissions.",
  "PERSIST_GRANTED": "Your data is protected from automatic deletion",
  "PERSIST_DENIED": "Local data could be deleted under storage pressure. Try re-enabling persistent storage.",
  "PERSIST_UNAVAILABLE": "Persistent storage not available in this environment (not applicable in native mode)"
 },
 "SELECTABLE": {
  "PRODUCT": "Product",
  "PRODUCT_SELECTION": "Product selection",
  "NOT_FOUND_HEADER": "Product with barcode \"{{code}}\" not found.",
  "NOT_FOUND_MESSAGE": "No product matched the scanned barcode. Try searching with the other methods."
 },
 "SETTING": {
  "TITLE": "Settings",
  "LOGOUT": "Log out",
  "PREFERENCES": "Preferences",
  "DARK_MODE": {
   "TITLE": "Dark mode",
   "DESCRIPTION": "Change the appearance of the app"
  },
  "LANGUAGE": {
   "TITLE": "Language",
   "DESCRIPTION": "Choose the app language"
  },
  "CONNECTIVITY": "Communication operations",
  "DOWNLOAD_TIME": {
   "TITLE": "Download time",
   "DESCRIPTION": "Measure download speed",
   "RESULT": "Download time (1Mb / 125KB): request {{requestMs}}ms ({{requestS}}s), download {{downloadMs}}ms ({{downloadS}}s)"
  },
  "UPLOAD_TIME": {
   "TITLE": "Upload time",
   "DESCRIPTION": "Measure upload speed"
  },
  "ACCOUNT": "Account",
  "COLLECTIONS": {
   "TITLE": "Collections",
   "VIEW": "View collections",
   "VIEW_DESCRIPTION": "Browse locally stored data",
   "ACTION_FOR": "Action for: {{collection}}",
   "REMOVED": "Collection <{{collection}}> was removed."
  },
  "UPDATE": {
   "TITLE": "Check for updates",
   "DESCRIPTION": "Get the latest version of the app"
  },
  "DELETE_ACCOUNT": {
   "TITLE": "Delete account",
   "DESCRIPTION": "This action cannot be undone",
   "CONFIRM_HEADER": "Delete account?",
   "CONFIRM_MESSAGE": "Your session and all locally stored data will be removed from this device. This action cannot be undone.",
   "CONFIRM_OK": "Delete",
   "DONE": "Account data removed from this device"
  },
  "ADMINISTRATION": "Administration",
  "VERSION": "Version",
  "INSTANCE": "Instance"
 },
 "CHANGE_PASSWORD": {
  "TITLE": "Change Password",
  "CURRENT": "Current password",
  "NEW": "New password",
  "CONFIRM": "Confirm new password",
  "HINT": "Minimum 6 characters",
  "SUBMIT": "Change password",
  "NO_SESSION": "Could not identify the user. Please log out and sign in again.",
  "SUCCESS": "Password changed successfully",
  "WRONG_CURRENT": "Current password is incorrect",
  "INVALID_DATA": "Invalid data. Make sure the new password has at least 6 characters.",
  "SETTINGS_DESC": "Change a marketer's password",
  "MISMATCH": "Passwords do not match"
 },
 "PSS": {
   "INDICATOR_AVAILABILITY": "Availability (OSA)",
   "INDICATOR_VISIBILITY": "Visibility (SOS)",
   "INDICATOR_PRICE_TAG": "Price · Price tag",
   "INDICATOR_PRICE_LIST": "Price · List price",
   "INDICATOR_PRICE_COMPETITION": "Price · Competition",
   "INDICATOR_STRUCTURE": "Structure · Shelf layout",
   "INDICATOR_ACTIVATION": "Activation · Promotion",
   "FINAL": "Final PSS",
   "FINAL_NOTE": "Average of stores, each one the average of its visits. Traffic light with the current scale.",
   "EVALUATED_OVER": "Evaluated over {{weight}}: an indicator does not apply or was not measured.",
   "POINTS_POSSIBLE": "Possible points",
   "POINTS_EARNED": "{{earned}} earned",
   "POINTS_EARNED_LABEL": "Points earned / possible",
   "EFFECTIVE_WEIGHT": "Effective weight",
   "ACT": {
     "NOT_APPLICABLE_SHORT": "Not applicable",
     "REASON": {
       "no_negotiation": "The store had no discount negotiation in force that day: Activation ({{weight}}) is left out and the visit is evaluated over the rest.",
       "no_negotiated_skus": "The negotiation in force covers no SKU of the store portfolio: Activation ({{weight}}) is left out."
     },
     "REASON_SHORT": {
       "no_negotiation": "No negotiation",
       "no_negotiated_skus": "No negotiated SKUs",
       "missing_offer": "Missing offer"
     },
     "STATUS": {
       "complete": "Measured",
       "no_measurement": "Not measured",
       "not_applicable": "Not applicable"
     },
     "COMPLIANT": "{{count}} of {{total}} negotiated SKUs with the promotion in place",
     "DISCOUNT": "Discount",
     "OFFER_TAG": "Offer tag",
     "OFFER_VS_MAX": "Offer / maximum",
     "OFFERS_NOT_NEGOTIATED": "{{count}} SKU(s) with an offer and no negotiation (informative: no effect on the score)."
   },
   "NEG": {
     "TITLE": "Discount negotiations",
     "HINT": "Activation only applies to visits of stores with a negotiation in force that day. Without one, the store is evaluated over 85%. Each negotiation has its own validity: adding one does not change visits outside it.",
     "CHAIN": "Chain",
     "ALL_CHAINS": "All chains",
     "NEW": "New negotiation",
     "EDIT": "Edit negotiation",
     "STORES": "Stores",
     "STORE": "Store",
     "PICK_STORES": "Pick stores",
     "WHOLE_CHAIN": "Whole chain ({{count}} stores)",
     "SKU": "SKU",
     "ALL_SKUS": "Every own-brand SKU",
     "DISCOUNT_PCT": "Negotiated discount (%)",
     "FROM": "From",
     "TO": "To",
     "VALIDITY": "From {{from}} to {{to}}",
     "EMPTY": "No negotiations yet. Without a negotiation, Activation does not apply.",
     "GROUP": {
       "current": "In force",
       "upcoming": "Upcoming",
       "past": "Expired"
     },
     "CREATED": "{{count}} negotiation(s) created",
     "SAVED": "Negotiation saved",
     "DELETED": "Negotiation deleted",
     "DELETE_HEADER": "Delete negotiation",
     "DELETE_MESSAGE": "Delete the negotiation of “{{store}}”? Visits within its validity are recalculated.",
     "SAVE_ERROR": "The negotiation could not be saved",
     "ERR_STORES": "Pick at least one store",
     "ERR_DISCOUNT": "The discount must be greater than 0% and less than 100%",
     "ERR_DATES": "The validity dates are missing",
     "ERR_DATE_ORDER": "“To” cannot be before “From”"
   },
   "SECTION_STRUCTURE": "Structure · Shelf layout index",
   "STRUCTURE_HINT": "Three criteria per SKU in stock. Compliance is the share of the weight of the criteria whose answer is the compliant one (with equal weights: 0%, 33%, 67% or 100%).",
   "STRUCT_CRITERION": "Criterion",
   "STRUCT_ANSWER": "Complies with",
   "STRUCT_WEIGHT": "Weight",
   "STRUCT_SHARE": "% of the indicator",
   "STRUCT_CRITERIA_SHORT": {
     "direct_block": "Block",
     "shelf_level": "Level",
     "competitor": "Competition"
   },
   "STRUCT_CRITERIA": {
     "direct_block": "Brand block",
     "shelf_level": "Shelf level",
     "competitor": "Next to competition"
   },
   "STRUCT_CRITERIA_HINT": {
     "direct_block": "Own-brand products of the same size are together, forming a brand block.",
     "shelf_level": "The product is on the 2 main shelves, at the eye level of an average person.",
     "competitor": "The product is next to the leading competition (Ariel or Las Llaves)."
   },
   "ERR_STRUCTURE_WEIGHTS": "Structure weights cannot be negative and at least one must be greater than 0",
   "STRUCT": {
     "COMPLIANT": "{{count}} of {{total}} SKUs in stock meet the 3 criteria"
   },
   "SCORE_SHORT": "Score",
   "SECTION_COMPETITION": "Competition price",
   "COMPETITION_HINT": "The own-brand price per kilo is compared with the average price per kilo of the competitors in its size block. A competitor price far from the visit median is left out of the average.",
   "COMP_RULE": "Compliance rule",
   "COMP_RULES": {
     "proportional": "Proportional",
     "all_or_nothing": "All or nothing"
   },
   "COMP_OUTLIER_PCT": "Outlier price if more than (%) away from the median",
   "COMP_BRANDS": "Competitor brands",
   "COMP_BRAND": "Brand",
   "COMP_ROLE": "Role",
   "COMP_ROLES": {
     "competitor": "Competitor (in the average)",
     "tracking": "Tracking (shown only)"
   },
   "COMP_PICK_BRAND": "Pick a brand",
   "COMP_ADD_BRAND": "Add brand",
   "COMP_BLOCKS": "Size blocks",
   "COMP_BLOCKS_HINT": "Each size competes with the units of its block. Include the size’s own units with their kilos: the price per kilo comes from there.",
   "COMP_MIN_DISCOUNT_PCT": "Minimum discount (%)",
   "COMP_UNIT": "Unit",
   "COMP_KG": "Kg",
   "COMP_ADD_UNIT": "Add unit",
   "ERR_COMP_OUTLIER": "The outlier threshold must be greater than 0%",
   "ERR_COMP_BRAND": "Every competitor brand must be picked and appear only once",
   "ERR_MIN_DISCOUNT": "The minimum discount of each size must be greater than 0% and at most 100%",
   "ERR_BLOCK_KG": "Every unit in a block needs its unit and its kilos (greater than 0)",
   "ERR_BLOCK_UNIT_TWICE": "A unit can only be in one block",
   "ERR_BLOCK_OWN_UNITS": "Each block must include the units of its own size with their kilos",
   "COMP": {
     "OUTLIERS": "{{count}} competitor price(s) more than {{pct}} away from the median were left out of the average: check the capture.",
     "OUTLIERS_SHORT": "Outlier prices",
     "COMPLIANT": "{{count}} of {{total}} SKUs in stock with the minimum discount",
     "BLOCK": "Block",
     "COMPETITION_KG": "Competition ($/kg)",
     "OWN_KG": "Own brand ($/kg)",
     "DISCOUNT": "Discount",
     "TARGET": "Target",
     "NOT_APPLICABLE": "No competition in the block: not applicable, its weight moves to the other block",
     "NOT_APPLICABLE_SHORT": "Not applicable",
     "COMPETITOR": "Competition recorded",
     "PER_KG": "$/kg",
     "STATUS": "Status",
     "STATUSES": {
       "ok": "In the average",
       "outlier": "Check capture (outlier)",
       "tracking": "Tracking",
       "no_stock": "No stock",
       "no_price": "No price"
     },
     "ROLE_LABEL": {
       "own": "Own brand",
       "competitor": "Competitor",
       "tracking": "Tracking"
     },
     "GAP": "{{discount}} (target {{target}})"
   },
   "INDICATOR_SHORT": {
     "availability": "Availability",
     "visibility": "Visibility",
     "price_tag": "Price tag",
     "activation": "Activation",
     "structure": "Structure",
     "price_competition": "Competition",
     "price_list": "List price"
   },
   "SECTION_PRICE_BLOCK": "3. Price",
   "SKUS_COUNT": "{{count}} SKU",
   "MEASUREMENT_REASON": {
     "missing_cm": "The shelf cm or the cm of a product in stock is missing. Visibility does not count in this visit and the PSS is computed over the rest.",
     "vale_exceeds_shelf": "The own-brand cm exceed the shelf. Visibility does not count in this visit and the PSS is computed over the rest.",
     "missing_price_tag": "A product in stock has no answer for “Price tag visible?”. Price tag does not count in this visit and the PSS is computed over the rest.",
     "missing_offer": "A negotiated product in stock has no answer for “Discount price?”, or says “Yes” without the price. Activation does not count in this visit and the PSS is computed over the rest.",
     "missing_structure": "An own-brand product in stock has no shelf layout answer (block, level or competition). Structure does not count in this visit and the PSS is computed over the rest.",
     "no_competition": "There are no valid competitor prices on the shelf. Competition does not count in this visit and the PSS is computed over the rest.",
     "missing_price": "An own-brand product in stock has no price. The indicator does not count in this visit and the PSS is computed over the rest.",
     "no_list_price": "A size has no list price in the weighting. List price does not count in this visit."
   },
   "MEASUREMENT_REASON_SHORT": {
     "missing_cm": "Missing cm",
     "vale_exceeds_shelf": "Own brand larger than the shelf",
     "missing_price_tag": "Missing “Price tag visible?”",
     "missing_offer": "Missing offer",
     "missing_structure": "Missing shelf layout",
     "no_competition": "No competition on the shelf",
     "missing_price": "Missing price",
     "no_list_price": "No list price"
   },
   "PRICE_WARNING": {
     "below_list": "Check capture",
     "above_list": "Above list price"
   },
   "PRICE": {
     "TAG": "Price tag",
     "OBSERVED": "Price",
     "LIST": "List price",
     "GAP": "Difference",
     "VS_LIST": "Price / list",
     "TAG_CONTRIBUTION": "Price tag contribution",
     "LIST_CONTRIBUTION": "List price contribution",
     "NO_ANSWER": "No answer",
     "YES": "Yes",
     "NO": "No",
     "REVIEW_CAPTURE": "Check capture",
     "TAG_COMPLIANT": "{{count}} of {{total}} SKUs in stock have a price tag",
     "LIST_COMPLIANT": "{{count}} of {{total}} SKUs in stock at or below the list price",
     "CAPTURE_WARNINGS": "{{count}} SKU(s) priced more than {{pct}} below the list price: check the capture. They still comply."
   },
   "LIST_PRICE": "List price ($)",
   "LIST_PRICE_HINT": "List price: suggested retail price of the size, in $ and with VAT. For a new price list, create a new version from the date it applies: previous visits do not change.",
   "SECTION_PRICE": "Price",
   "PRICE_HINT": "List price complies when the shelf price is at or below the list price. A price far below still complies, but it is flagged to check the capture.",
   "PRICE_WARNING_PCT": "“Check capture” warning when more than (%) below",
   "ERR_LIST_PRICE": "Every size needs a list price greater than 0",
   "ERR_PRICE_WARNING": "The capture warning must be between 0% and 99%",
   "WIDGET_SUBTITLE": "The 7 indicators and the final traffic light",
   "SKUS": {
     "SECTION": "Analysis by SKU",
     "SECTION_Q": "How each product is doing, with its photo",
     "GALLERY_TITLE": "Products",
     "GALLERY_Q": "Score of each own SKU (what it earned out of what it could earn) and its compliance by indicator. Tap one to see the detail.",
     "LOST_POINTS": "Takes {{value}} pp off the PSS",
     "CUMULATIVE": "Cumulative: {{value}} of what is lost",
     "OWN": "Own brand",
     "COMPETITION": "Competition",
     "PER_KG": "Per kg",
     "CM": "Space",
     "CM_SHARE": "Share of own space",
     "IN_STOCK": "In stock",
     "PARETO_TITLE": "Which SKU costs us the most points?",
     "PARETO_Q": "Final PSS points each SKU loses, by indicator, from most to least. On the right, how much of the total loss they add up to.",
     "NO_LOSSES": "No SKU loses points in the period.",
     "AVAILABILITY_TITLE": "Availability",
     "AVAILABILITY_Q": "Share of visits with each answer. The ones missing most, on top.",
     "AVAILABILITY": {
       "high": "More than 20",
       "low": "1 to 20",
       "zero": "Out of stock",
       "unregistered": "Not recorded"
     },
     "PRICE_TITLE": "Price",
     "PRICE_Q": "Range of observed prices, average and list price of each own SKU.",
     "PRICE_KG_Q": "Price per kilo of the own brand and the competition, by size.",
     "PRICE_UNIT": "Unit",
     "PRICE_RANGE": "Range",
     "PRICE_AVG": "Average",
     "PRICE_LIST": "List price",
     "ABOVE_LIST": "Above list price in {{value}} of visits",
     "NO_PRICES": "No prices recorded in the period.",
     "SPACE_TITLE": "Shelf space",
     "SPACE_Q": "Average centimeters of each SKU in stock, own and competition, by size.",
     "LAST_PHOTO_TITLE": "Photo from the latest visit",
     "LAST_PHOTO_Q": "Evidence from a single visit: the most recent one in the filter. Not the average.",
     "LAST_PHOTO_DATE": "Visit on",
     "LAST_PHOTO_STORE": "Store",
     "LAST_PHOTO_BY": "Merchandiser",
     "LAST_PHOTO_NOTE": "The final PSS and the points beside it average every visit in the period; this photo only shows the shelf on that visit, so it may not match them.",
     "LAST_PHOTO_EMPTY": "No visit in the period has an evidence photo.",
     "LAST_PHOTO_ZOOM": "Tap to enlarge",
     "LAST_PHOTO_VIEWER": "Latest visit · {{date}}",
     "OUT_OF_STOCK": "Out of stock or not recorded: {{value}}",
     "DETAIL_TITLE": "SKU detail",
     "EARNED": "Earned",
     "LOST": "Lost",
     "BY_INDICATOR": "By indicator",
     "SERIES_OWN": "Score per day",
     "SERIES_COMP": "Price per kilo per day",
     "CHAINS_OWN": "Score by chain",
     "CHAINS_COMP": "Price per kilo by chain",
     "STORES_OWN": "Stores where it does worst",
     "STORES_COMP": "Stores with the highest price per kilo",
     "COL_STORE": "Store",
     "COL_SCORE": "Score",
     "COL_LAST_AVAILABILITY": "Last availability",
     "COL_LAST_PRICE": "Last price",
     "OPEN_VISIT": "View visit"
   },
   "DASH": {
     "FILTERS": "Dashboard filters",
     "FILTER_CHAIN": "Chain",
     "FILTER_REGION": "Region",
     "ALL": "All",
     "KPI_STORES": "Stores evaluated",
     "KPI_VISITS": "Evaluable visits",
     "KPI_GREEN": "Stores in green",
     "KPI_NEGOTIATIONS": "Active negotiations",
     "OF": "of {{total}}",
     "GREEN_HINT": "{{band}}: {{min}} % or more",
     "NEGOTIATIONS_NONE": "Activation does not apply",
     "NEGOTIATIONS_SOME": "Activation in play",
     "NO_PREVIOUS": "No visits in the previous period: comparison arrows appear once there are.",
     "SECTION_RESULT": "Result",
     "SECTION_RESULT_Q": "How are we doing and where are points lost?",
     "GAUGE_Q": "Store average, with the scorecard traffic light",
     "CASCADE_TITLE": "From 100 points to the final PSS",
     "GROUPS_OVERALL": "Overall {{value}}",
     "POINTS_TOTAL": "Earned {{earned}} of {{possible}} possible · Final PSS {{final}}",
     "POINTS_WEIGHT": "weight {{weight}}",
     "POINTS_LOST": "Lost",
     "POINTS_EARNED": "Earned",
     "CASCADE_Q": "Each bar spans the indicator's weight: earned in its color, lost in gray, and what does not apply or was not measured, hatched.",
     "CASCADE_EXCLUDED": "Out of the calculation",
     "CASCADE_PENDING": "Pending",
     "CASCADE_READING_2": "Biggest losses: {{first}} (−{{firstLoss}}) and {{second}} (−{{secondLoss}}).",
     "CASCADE_READING_1": "Biggest loss: {{first}} (−{{firstLoss}}).",
     "CASCADE_EXCLUDED_NOTE": "Out of the calculation in some visit (not measured or does not apply): {{names}}. On average, the PSS is evaluated over {{possible}} possible.",
     "CASCADE_NOTE": "Points are the store average; the final PSS is computed per store over its possible points.",
     "PROFILE_TITLE": "Indicator profile",
     "PROFILE_Q": "Compliance of each indicator and its effective weight",
     "VIEW_BARS": "Bars",
     "VIEW_RADAR": "Radar",
     "EFFECTIVE_WEIGHT": "effective weight {{value}}",
     "WEIGHT_OUT": "weight {{value}} · out of the calculation",
     "POINTS_OF": "{{earned}} of {{weight}}",
     "NOT_APPLICABLE": "Does not apply",
     "NO_MEASUREMENT": "Not measured in the period",
     "NO_SCORE": "No score",
     "OUT_OF_CALC": "out of the calculation",
     "RADAR_NOTE": "On the radar, an indicator that does not apply or was not measured is drawn at 0. The bars show it apart.",
     "HEATMAP_TITLE": "Products × indicator",
     "HEATMAP_Q": "Which product fails and where (compliance in %)",
     "HEATMAP_MISSING": "No column because it was not measured in the period: {{names}}.",
     "ABBR": {
       "availability": "Avail.",
       "visibility": "Visib.",
       "price_tag": "Tag",
       "price_list": "List",
       "price_competition": "Comp.",
       "activation": "Activ.",
       "structure": "Struct."
     },
     "SECTION_STORES": "Stores",
     "SECTION_STORES_Q": "How the period's stores are distributed",
     "FEW_STORES": "{{count}} store(s) have a final PSS in the period: these charts become meaningful as more visits come in.",
     "DONUT_TITLE": "Stores by traffic light",
     "DONUT_Q": "How many stores fall in each band",
     "DONUT_CENTER": "stores",
     "RANKING_TITLE": "Store ranking",
     "RANKING_Q": "Tap a store to see the breakdown of its last visit",
     "WORST": "Worst",
     "BEST": "Best",
     "GROUPS_TITLE": "Comparison",
     "GROUPS_Q": "How the final PSS of the chosen chain or region is built: what each indicator adds. The dashed line is the overall PSS.",
     "NO_NAME": "No name",
     "SECTION_TREND": "Comparison and trend",
     "SECTION_TREND_Q": "How the PSS is built per chain or region and how it evolves over time",
     "TREND_TITLE": "Final PSS per day",
     "TREND_Q": "With the traffic-light bands in the background",
     "FEW_POINTS": "There is only one day with visits in the period: the line appears from the second one.",
     "SPARKS_NOTE": "Score of each indicator per day. The number is the last day and the arrow compares it with the previous day with visits.",
     "SECTION_DETAIL": "Detail per indicator",
     "SECTION_DETAIL_Q": "What is specific to each indicator",
     "SCORE_FOOT": "Score {{score}} · {{earned}} earned",
     "VIS_Q": "Share of shelf and split by size",
     "COMP_Q": "Own-brand price per kg against the competition average",
     "COMP_OWN": "Own brand",
     "COMP_COMPETITION": "Competition (average)",
     "COMP_MAX": "Maximum price to comply",
     "COMP_NOTE": "The vertical mark is the maximum price that meets the block's minimum discount.",
     "STRUCT_Q": "Products in stock that meet each criterion",
     "STRUCT_MET": "{{met}} of {{total}}",
     "ACT_Q": "Negotiated promotion: price tag and offer price",
     "ACT_MANAGE": "Negotiations",
     "ACT_EMPTY_TITLE": "No active negotiations in the period",
     "ACT_EMPTY_BODY": "Activation neither adds nor subtracts. Once negotiations are loaded, the compliance of each negotiated product shows here.",
     "MISSING_TITLE": "What is missing",
     "MISSING_Q": "Visits where an indicator was not measured or that could not be evaluated",
     "MISSING_EMPTY": "Nothing pending: the period's visits measured everything that applied.",
     "NOT_EVALUABLE": "Visit not evaluable",
     "COL_CHAIN": "Chain",
     "COL_INDICATOR": "Indicator",
     "COL_REASON": "Reason",
     "COL_VISITS": "Visits"
   },
   "PARTIAL": "Partial PSS",
   "PARTIAL_NOTE": "Sum earned in the indicators implemented so far. The ceiling is the best reachable score if the pending ones were perfect.",
   "EVALUABLE_NOTE": "An indicator does not apply or was not measured in this visit: it is evaluated over {{weight}} of the PSS (the possible points of the visit).",
   "VISITS_OF": "{{count}} of {{total}} visits",
   "STEP_POINTS": "{{value}} pp of the PSS",
   "SECTION_VISIBILITY": "Visibility",
   "VISIBILITY_HINT": "Step 1: own-brand share of the shelf, against the target. Step 2: how that space is split across sizes, against the ideal mix. The Visibility weight is split between both steps.",
   "VIS_TARGET_PCT": "Shelf share target (%)",
   "VIS_STEP1_PCT": "Step 1 · shelf share (%)",
   "VIS_STEP2_PCT": "Step 2 · size mix (%)",
   "SPACE_TARGET_PCT": "Ideal mix (%)",
   "SPACE_TARGET_HINT": "Ideal mix: how the own-brand space should be split across sizes (Visibility step 2). Every size needs more than 0% and they must add up to 100%.",
   "ERR_SPACE_TARGET_ZERO": "Every size needs an ideal mix greater than 0%",
   "ERR_SPACE_TARGET_SUM": "The ideal mix must add up to 100%",
   "ERR_VIS_TARGET": "The shelf share target must be greater than 0% and at most 100%",
   "ERR_VIS_STEP1": "The step 1 weight must be between 0% and 100%",
   "VIS": {
     "PARTICIPATION": "Shelf share",
     "TARGET": "target {{value}}",
     "MIX": "Space split by size",
     "MIX_REAL": "Actual",
     "MIX_IDEAL": "Ideal",
     "CM_CAPTION": "Own brand: {{vale}} of {{shelf}} of shelf",
     "STEP1": "Step 1 · shelf share",
     "STEP2": "Step 2 · mix",
     "NOT_APPLICABLE": "Not applicable",
     "VISIT_SCORE": "Visit score",
     "SCORE": "Visibility score",
     "CM": "cm",
     "CM_MISSING": "Missing",
     "NO_MEASUREMENT": "Not measured",
     "NO_MEASUREMENT_SHORT": "Not measured",
     "MISSING_INFO": "Missing information"
   },
   "VIS_STATUS": {
     "complete": "Measured",
     "no_measurement": "Not measured"
   },
   "SCORE": "Availability score",
   "EARNED": "Earned",
   "EARNED_OF": "Earned (of {{weight}})",
   "LOSS": "Lost",
   "CEILING": "PSS ceiling",
   "STORES": "Stores",
   "VISITS": "Visits",
   "SKUS_REGISTERED": "SKUs recorded",
   "SKUS_TITLE": "SKU by SKU",
   "SKU": "SKU",
   "SIZE": "Size",
   "RECORDED": "Recorded",
   "COMPLIANCE": "Compliance",
   "WEIGHT": "Weight",
   "CONTRIBUTION": "Contribution",
   "TOTAL": "Total",
   "NOT_REGISTERED": "Not recorded (counts as 0)",
   "AVAILABILITY": {
     "zero": "0 units",
     "low": "Between 1 and 20 units",
     "high": "More than 20 units"
   },
   "PATH_TITLE": "Path to the traffic light",
   "PENDING": "Pending",
   "FINAL_BAND": "Final band",
   "FINAL_PENDING": "Pending: {{count}} indicators to go",
   "BREAKDOWN_TITLE": "Perfect Store · Visit breakdown",
   "CLOSE": "Close",
   "LOAD_ERROR": "Could not load Perfect Store data",
   "REASON": {
     "no_portfolio": "The chain has no own-brand SKUs assigned: the visit cannot be evaluated",
     "no_version": "The visit predates the first weighting version"
   },
   "NO_CHAIN": "No chain",
   "NO_DATA": "No evaluable visits in this period",
   "VISITS_COUNT": "{{count}} visit(s)",
   "STORES_COUNT": "{{count}} store(s)",
   "PERIOD_DAYS": "{{days}} days",
   "PERIOD_YEAR": "1 year",
   "SKU_CHART": "Compliance by SKU",
   "TREND_CHART": "Score by day",
   "STORE_WEIGHTED_NOTE": "Each store weighs the same: average of its visits in the period.",
   "WEIGHTING": "Weighting",
   "WEIGHTING_TITLE": "Perfect Store",
   "TABS": {
     "WEIGHTING": "Weighting",
     "NEGOTIATIONS": "Negotiations"
   },
   "WEIGHTING_HINT": "Each visit is evaluated with the version valid on its date. To fix a version, edit it: its visits are recalculated. To change the rules from a date onwards without touching history, create a new version.",
   "VERSIONS": "Versions",
   "NEW_VERSION": "New version",
   "NEW_VERSION_HINT": "Copies an existing version with another start date. You can edit it afterwards.",
   "BASE_VERSION": "Copy from",
   "VERSION_NAME": "Name",
   "VALID_FROM": "Valid from",
   "CREATE": "Create",
   "CURRENT": "Current",
   "VALIDITY": "Valid from {{from}} to {{to}}",
   "OPEN_ENDED": "no end date",
   "LAST_MODIFIED": "Modified by {{user}} on {{date}}",
   "VERSION_CREATED": "Version created",
   "EDIT_VERSION": "Edit weighting",
   "EDIT_IMPACT": "This version evaluates {{count}} visits: saving it recalculates their scores.",
   "UNWEIGHTED_WARNING": "These own-brand SKUs are assigned to chains but their size has no weight in this version, so they are not evaluated:",
   "SECTION_GENERAL": "General",
   "NOTES": "Notes",
   "SECTION_INDICATORS": "Indicator weights",
   "INDICATORS_HINT": "Share of the PSS each indicator contributes. They must add up to 100%. The final band is computed only when all 7 are validated.",
   "INDICATOR": "Indicator",
   "WEIGHT_PCT": "Weight (%)",
   "VALIDATED": "Validated",
   "SUM": "Sum: {{value}}%",
   "SECTION_SEGMENTS": "Split by size",
   "SEGMENTS_HINT": "Share of the weight each size takes; within a size it is split equally among its SKUs. They must add up to 100%.",
   "SHARE_PCT": "Share (%)",
   "UNITS": "Catalog units",
   "PICK_UNITS": "Pick units",
   "ADD_SEGMENT": "Add size",
   "REMOVE": "Remove",
   "SECTION_SCORES": "Availability compliance",
   "SCORES_HINT": "What each marketer answer is worth (in %).",
   "SECTION_BANDS": "Traffic light scale",
   "BANDS_HINT": "Each band starts at \"From (≥)\". The lowest band must start at 0%.",
   "BAND_NAME": "Classification",
   "BAND_FROM": "From (≥ %)",
   "BAND_POINTS": "Points",
   "BAND_COLOR": "Color",
   "COLOR": {
     "green": "Green",
     "yellow": "Yellow",
     "orange": "Orange",
     "red": "Red",
     "black": "Black"
   },
   "ADD_BAND": "Add band",
   "SAVE": "Save",
   "SAVED": "Weighting saved",
   "SAVE_CONFIRM_HEADER": "Recalculate visits?",
   "SAVE_CONFIRM_MESSAGE": "This version evaluates {{count}} visits. Saving recalculates their scores with the new values.",
   "DELETE_VERSION": "Delete version",
   "DELETED": "Version deleted",
   "DELETE_CONFIRM_HEADER": "Delete version",
   "DELETE_CONFIRM_MESSAGE": "Delete version \"{{name}}\"? It has no visits.",
   "ERROR_HEADER": "Perfect Store",
   "SAVE_ERROR": "Could not save the weighting",
   "ERR_NAME": "Name is missing",
   "ERR_DATE": "Start date is missing",
   "ERR_INDICATOR_SUM": "Indicator weights must add up to 100%",
   "ERR_NO_SEGMENTS": "Define at least one size",
   "ERR_SEGMENT_SUM": "The split by size must add up to 100%",
   "ERR_SEGMENT_NAME": "Each size needs a name",
   "ERR_BAND_ZERO": "The lowest traffic light band must start at 0%",
   "ERR_SCORES": "Scores must go from 0 to 100 and grow with the stock",
   "REASON_SHORT": {
     "no_portfolio": "Chain without portfolio",
     "no_version": "No weighting in force"
   }
 }
}
